// extracted by mini-css-extract-plugin
module.exports =  {"chip":"Chip-module_chip_e90be"};